export function getNoImpact(score: number | undefined) {
  return typeof score !== undefined && score === 0;
}
